// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"intro-module--jumbotron--3xTPu","heading":"intro-module--heading--182Q2"};